import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Input,
  Row,
  Col,
  CardTitle,
} from "reactstrap";
import useToken from "../../helpers/useToken";
import TMHLoader from "../TMHLoader/TMHLoader";

export default function RokuRemoteConfig({ notify }) {
  const { token } = useToken();
  const [config, setConfig] = useState();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const initData = () => {
      setIsLoading(true);
      console.log("RokuRemoteConfig:: get data");
      const myHeaders = new Headers();
      myHeaders.append("Cache-Control", "no-cache");

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      fetch(
        process.env.REACT_APP_BASE_URL + "roku_remote/config",
        requestOptions
      )
        .then((response) => {
          return new Promise((resolve) =>
            response.json().then((json) =>
              resolve({
                status: response.status,
                ok: response.ok,
                json,
              })
            )
          );
        })
        .then((result) => {
          var json = result.json;
          // console.log(json)
          if (result.ok) {
            setConfig(json.data);
          } else {
            // console.log(result.json.message)
          }
          setIsLoading(false);
        });
    };

    initData();
  }, [token]);

  const handleUpdateConfig = async () => {
    setIsLoading(true);
    console.log("RokuRemoteConfig: PUT data");
    const myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify({
        data: config,
      }),
    };

    fetch(process.env.REACT_APP_BASE_URL + "roku_remote/config", requestOptions)
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        );
      })
      .then(async (result) => {
        var json = result.json;
        // console.log(json)
        if (result.ok) {
          setConfig(json.data);
          notify("tl", "Save Config List Success!", "success");
        } else {
          // console.log(result.json.message)
          notify("tl", "Save Config List Failed: !" + json?.message, "danger");
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <TMHLoader active={isLoading}>
      <Card>
        <CardHeader>
          <CardTitle className="text-center" tag="h2">
            Roku Remote EXT Config
          </CardTitle>
        </CardHeader>
        <CardBody className="text-white">
          <Row className="my-4">
            <Col md="4">
              Search:
              <Input
                className="p-2"
                value={config?.search}
                onChange={(e) =>
                  setConfig({ ...config, search: e.target.value })
                }
                type="text"
                bsSize="lg"
                rows="5000"
                cols="50"
              />
            </Col>
          </Row>
          <Row className="text-center">
            <Col md="12">
              <Button onClick={() => handleUpdateConfig()} color="success">
                Update
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </TMHLoader>
  );
}
